import React from "react";
import {Picker} from "../../Utils/Picker";


export default function TrackingOptionsPicker({name, label, value, onChange, blank, disabled, className, inlineEdit, onSave, editable, setEditable, options}){

    return (
        <Picker
            optionField={"name"}
            name={name}
            label={label}
            value={value}
            onSave={onSave}
            onChange={onChange}
            blank={blank}
            disabled={disabled}
            className={className ? className : " small-column"}
            inlineEdit={inlineEdit}
            editable={editable}
            setEditable={setEditable}
            options={options}
        />
    )

}